import { NgForOf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ItemsHttpService } from 'src/app/services/http-services/items/items-http.service';
import { ListsHttpService } from 'src/app/services/http-services/lists/lists-http.service';
import { PostsHttpService } from 'src/app/services/http-services/posts/posts-http.service';

@Component({
  selector: 'app-report-modal',
  standalone: true,
  imports: [NgForOf, TranslateModule],
  templateUrl: './report-modal.component.html',
})
export class ReportModalComponent {
  @Input() entityType = '';
  @Input() entityId!: number;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() reportSent: EventEmitter<void> = new EventEmitter<void>();
  reportReasons = ['I just don\'t like it', 'It\'s spam', 'Nudity or sexual activity', 'Hate speech or symbols', 'Violence or dangerous organizations', 'Bullying or harassment'];

  constructor(
    private toastService: ToastrService,
    private postsHttpService: PostsHttpService,
    private itemsHttpService: ItemsHttpService,
    private listsHttpService: ListsHttpService
  ) { }

  report(reportReason: string): void {
    if (this.entityType === 'list') {
      this.reportList(reportReason);
    } else if (this.entityType === 'item') {
      this.reportItem(reportReason);
    } else if (this.entityType === 'post') {
      this.reportPost(reportReason);
    } else {
      this.reportReview(reportReason);
    }
  }

  reportList(reportReason: string): void {
    this.listsHttpService.sendListReport(this.entityId, { body: reportReason }).then(res => {
      if (res.code === 200) {
        this.toastService.success(res.message);
        this.reportSent.emit();
      }
    }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
      Object.values(error.errors).forEach(error => this.toastService.error());
    });
  }

  reportItem(reportReason: string): void {
    this.itemsHttpService.sendItemReport(this.entityId, { body: reportReason }).then(res => {
      if (res.code === 200) {
        this.toastService.success(res.message);
        this.reportSent.emit();
      }
    }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
      Object.values(error.errors).forEach(error => this.toastService.error());
    });
  }

  reportReview(reportReason: string): void {
    this.itemsHttpService.sendReviewReport({ reviewId: this.entityId }, { body: reportReason }).then(res => {
      if (res.code === 200) {
        this.toastService.success(res.message);
        this.reportSent.emit();
      }
    }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
      Object.values(error.errors).forEach(error => this.toastService.error());
    });
  }

  reportPost(reportReason: string): void {
    this.postsHttpService.sendPostReport({ postId: this.entityId }, { body: reportReason }).then(res => {
      if (res.code === 200) {
        this.toastService.success(res.message);
        this.reportSent.emit();
      }
    }).catch(({ error }: { error: { errors: { [key: string]: string } } }) => {
      Object.values(error.errors).forEach(error => this.toastService.error());
    });
  }

}
